import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PendingReceipt } from '@jobos/shared';

interface PendingReceiptsBannerProps {
  pendingReceipts: PendingReceipt[];
  onContinue: () => void;
  onDismissAll: () => void;
}

export function PendingReceiptsBanner({
  pendingReceipts,
  onContinue,
  onDismissAll,
}: PendingReceiptsBannerProps) {
  if (pendingReceipts.length === 0) return null;

  const count = pendingReceipts.length;

  return (
    // Message and buttons on one line is 390px of content in 340px of room, and
    // the loser is the message — which is the part that says what to do. So on a
    // phone they get a line each and the buttons split the second one.
    <div className="mb-4 flex flex-col gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-2 text-sm text-amber-800">
        <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0 sm:mt-0" />
        <span>
          {count} receipt{count !== 1 ? 's' : ''} still need{count === 1 ? 's' : ''} details
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={onContinue}
          className="min-h-[44px] flex-1 border-amber-300 text-amber-800 hover:bg-amber-100 sm:min-h-0 sm:flex-none"
        >
          Continue
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={onDismissAll}
          className="min-h-[44px] flex-1 text-amber-700 hover:bg-amber-100 sm:min-h-0 sm:flex-none"
        >
          {count === 1 ? 'Dismiss' : 'Dismiss all'}
        </Button>
      </div>
    </div>
  );
}
